import styled, { css } from 'styled-components';

import { colors } from '@10d/tend-ui-tokens/samolet';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 200px;

  .hidden-labels {
    font-size: 12px;
  }
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: flex-end;
  padding-bottom: 5px;
  height: 24px;
`;

const commonLabelStyle = css`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.gray900};
`;

export const Label = styled.span`
  ${commonLabelStyle}
  margin-bottom: 4px;
`;

export const RowLabel = styled.span`
  margin-left: 10px;
  ${commonLabelStyle}
`;

export const ReqLabel = styled.span`
  color: ${colors.red600};
`;
